import { useModal } from "@erp/shared/composables/useModal";
import { useState } from "@erp/shared/composables/useState";
export const useStockDetailDialog = () => {
    const [clickedRow, setClickedRow] = useState(null);
    const modal = useModal();
    const openStockDetailDialog = (item) => {
        setClickedRow(item);
        modal.openExclusive("StockDetailDialog", {
            clickedRow: clickedRow.value,
            onClose: () => {
                modal.closeAll();
            },
        });
    };
    return {
        clickedRow,
        setClickedRow,
        openStockDetailDialog,
    };
};
